import { Account } from '../lib/accounts/context';
import { OnboardingState, OnboardingStep } from './types';

export const accountOnboardingBasePath = (account: Pick<Account, 'slug'>) =>
  `/${account.slug}/onboarding`;

export const shouldRedirectToOnboarding = (
  account: Pick<Account, 'slug' | 'isOnboarded'>,
  pathname: string,
) => !pathname.startsWith(accountOnboardingBasePath(account)) && !account.isOnboarded;

const getStepPath = (step: OnboardingStep, account: Pick<Account, 'slug'>) => {
  switch (step) {
    case 'start':
      return `${accountOnboardingBasePath(account)}/start`;
    case 'legal':
      return `${accountOnboardingBasePath(account)}/legal`;
    case 'welcomeSurvey':
      return `${accountOnboardingBasePath(account)}/welcome-survey`;
    case 'setupCall':
      return `${accountOnboardingBasePath(account)}/setup-call`;
    case 'connection':
      return `${accountOnboardingBasePath(account)}/connection`;
    case 'complete':
      return `${accountOnboardingBasePath(account)}/complete`;
    default:
      throw new Error(`Unknown onboarding step: ${step}`);
  }
};

const getNextStep = (onboardingState: OnboardingState): OnboardingStep => {
  const { hasConsented, hasConnection, hasPassedSetupCallStep, hasBookedSetupCall, welcomeSurvey } =
    onboardingState;
  return !hasConsented
    ? 'legal'
    : welcomeSurvey === undefined
      ? 'welcomeSurvey'
      : !hasBookedSetupCall && !hasPassedSetupCallStep
        ? 'setupCall'
        : !hasConnection
          ? 'connection'
          : !hasBookedSetupCall
            ? 'setupCall'
            : 'complete';
};

export const getNextStepPath = (
  onboardingState: OnboardingState,
  account: Pick<Account, 'slug'>,
) => (onboardingState.hasOnboarded ? '/' : getStepPath(getNextStep(onboardingState), account));
